let items = {
  title: 'Produtos',
  title_s: 'Produto',
  icon: 'mdi-package-variant',
  new: {
    title: 'Novo Produto',
    uploadImage: 'Enviar Foto',
    removeImage: 'Remover Foto',
    category: 'Categoria',
    noChildrenText: 'Nenhuma Sub-Categoria',
    noCategoriesText: 'Sem Categorias',
    noResultsText: 'Categoria não encontrada',
    rules: {
      titleRules: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 74) || 'O Título deve ter menos que 74 caracteres'
      ],
      categoryRules: [
        v => !!v || 'Categoria é obrigatório'
      ]
    }
  },
  edit: {
    title: 'Editar Produto',
    changeImage: 'Alterar Foto'
  },
  view: {
    view: 'Ver',
    close: 'Fechar',
    history: {
      created: 'Criado',
      edited: 'Editado',
      unknown: 'Desconhecido'
    }
  },
  stock: {
    enabled: 'Habilitado',
    disabled: 'Desabilitado',
    unavailable: 'Fora de Estoque',
    available: (qty) => `${qty} em Estoque`
  },
  status: {
    inactive: 'Desativado',
    active: 'Ativo',
    activate: 'Ativar',
    deactivate: 'Desativar'
  },
  categories: {
    title: 'Categorias de Produtos',
    add: 'Adicionar Categoria'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Nenhum produto cadastrado',
    no_results: 'Nenhum produto encontrado',
    items_per_page: 'Produtos por página',
    headers: {
      id: 'ID',
      code: 'Cod',
      created: 'Criação',
      thumb: ' ',
      subcategory: 'Categoria',
      stock: 'Ger. de Estoque',
      qty: 'Quant. em Estoque',
      title: 'Título',
      description: 'Descrição',
      stock_: 'Estoque',
      price: 'Preço',
      action: 'Ações'
    }
  },
  results: {
    title: 'Resultados',
    all: 'Todos',
    deleted: 'Excluidos'
  },
  actions: {
    view: 'Ver',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir'
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Produto',
    thumbDelete: 'Tem certeza que deseja remover a Imagem ?'
  },
  messages: {
    error: {
      not_found: 'Produto não encontrado'
    }
  }
}

export default items
